<template>

  <b-row>
    <b-col md="12" class="mb-4 customer-ratings " v-if="(editable || offer.showSeminarReviews) && display">
      <Reviews 
        :heading="heading" 
        :review="seminarRating" 
        :hideAt="hideAt"
        :constituents="constituents"
        :name="$t('reviews.seminarName')"
        show-author show-company show-city show-date
        @toggle="(value) => offerSet({showSeminarReviews: value ? 1 : 0})"
        @dirty="() => $emit('dirty')"
        :editable="editable"
        :initial="offer.showSeminarReviews === 1 ? true : false"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Reviews from './Reviews'

export default {
  name: 'SeminarReviews',
  components: {Reviews},
  props:{
    editable: Boolean, 
  },
  data() {
    return {
      constituents: ['seminarReview'],
      hideAt: 3
    }
  },
  methods: {
    ...mapMutations(['offerSet'])
  },
  computed: {
    ...mapGetters(['seminarRating', 'offer']),
    heading() {
      return this.$t('reviews.seminarHeading');
    },
    display() {
      return this.seminarRating && this.seminarRating.length != 0
    }
  }
}
</script>
